<template lang="pug">
    .main.col.col-center 
        van-image.header(:src='headImg')
        .name {{name}}
        .title 邀请视频问诊
        .row.row-around.btn-wrap 
            .col.col-center(@click='accept')
                img.btn-img(src='~@/assets/image/icon_videoCall@2x.png')
                .btn-text 接通
            .col.col-center(@click='reject')
                img.btn-img(src='~@/assets/image/icon_endCall@2x.png')
                .btn-text 挂断
    </template>
    <script>
    import eventEmitter from '@/utils/bus'
    export default {
        data() {
            return {
                name: '',
                headImg: '',
            }
        },
        computed: {},
        beforeMount() {
            this.getDoctorInfo()
            eventEmitter.on('leave', () => {
                this.$router.back(0)
            })
        },
    
        methods: {
            async getDoctorInfo() {
                const { sponsor } = this.$route.query
                const params = { doctorID: sponsor }
    
                const res = await this.$_http.get(this.$_API.GET_DOCTOR_INFO_BY_ID, { params })
                if (res.success) {
                    this.name = res.data.doctorName
                    this.headImg = res.data.photoUrl
                }
            },
            accept() {
                const params = this.$route.query
    
                this.$router.replace({
                    path: '/video/page',
                    query: params,
                })
            },
            reject() {
                //1 结束  2 取消  3 拒绝
                //发送 im 自定义消息
                const params = this.$route.query
                this.$trtcCalling.rejectInvite(params)
                this.$router.back()
            },
        },
    }
    </script>
    <style lang="stylus" scoped>
    .main
        background: #001135
        height: 100vh
        width: 100vw
        position: relative
        font-size: 16px
    .header
        height: 72px
        width: 72px
        margin-top: 88px
        border-radius: 50%
        overflow: hidden
    .name
        color: #fff
        margin-top: 12px
        font-weight: 500
    .title
        font-size: 14px
        color: rgba(255, 255, 255, 0.5)
        margin-top: 12px
    .btn-img
        width: 64px
        height: 64px
    .btn-wrap
        position: absolute
        width: 100%
        left: 0
        bottom: 40px
    .btn-text
        color: #fff
        margin-top: 10px
    </style>
    